module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_6.5e2e4f7e.png";